import { useLazyQuery } from "@apollo/client";
import { LocalizedValueInput, SupportedLanguages } from "gql/graphql";
import Form from "@/shared/form/form";
import { TRANSLATE_LOCALIZED_VALUE } from "../api/translate-localized-value";
import { useLocalizedControl } from "./localized-value-control-context";

export function useTranslateLocalizedValue() {
  const form = Form.useFormInstance();

  const {
    formItemProps: { name },
    languages,
    languageToControlName,
    translationContext,
  } = useLocalizedControl();

  const [translateLocalizedValue, { loading }] = useLazyQuery(
    TRANSLATE_LOCALIZED_VALUE,
    { fetchPolicy: "no-cache" },
  );

  const basePath = Array.isArray(name) ? name : [name];

  // без подписки на значения кнопка не узнает, что поля начали заполнять
  Form.useWatch(basePath, form);

  const pathOf = (language: SupportedLanguages) => [
    ...basePath,
    languageToControlName(language),
  ];

  const currentValue = () =>
    languages.reduce<LocalizedValueInput>((value, language) => {
      const fieldValue: string | null | undefined = form.getFieldValue(
        pathOf(language),
      );

      return {
        ...value,
        [languageToControlName(language)]: fieldValue?.trim() || null,
      };
    }, {});

  const value = currentValue();

  const isEmpty = Object.values(value).every((fieldValue) => !fieldValue);

  const translate = async () => {
    const { data } = await translateLocalizedValue({
      variables: { value, context: translationContext },
    });

    if (!data) return;

    const translated = data.translateLocalizedValue;

    form.setFields(
      languages.map((language) => ({
        name: pathOf(language),
        value: translated[languageToControlName(language)] ?? undefined,
        errors: [],
      })),
    );
  };

  return { translate, loading, isEmpty };
}
